import React, { useState } from 'react'
import { View } from 'react-native'
import { Layout } from '@ui-kitten/components'
import { HotUpdater } from '@hot-updater/react-native'
import { useDispatch } from 'react-redux'
import { DeviceEventEmitter } from 'react-native'
import { useSelector } from 'react-redux'
import { StyleService, useStyleSheet } from '@src/style/service'
import { Apollo } from '@config'
import { Section, CommonSelect } from '@components'
import { AdminUserAutocomplete } from '@containers'
import { SelectOption } from '@src/components/CommonSelect.types'
import { Text } from '@components/base'
import { MobileAppFeature } from '@src/types'
import { User } from '@src/utils'
import { useTimeZone } from '@src/config/timezone'
import { clientConfigTimeZonesSelector } from '@src/selectors/app'

export const AdminSettings = () => {
  const dispatch = useDispatch()
  const [timeZone, setTimeZone] = useTimeZone()

  const onSelectTimeZone = (item: SelectOption) => {
    if (item.text !== timeZone) {
      setTimeZone(item.text)

      dispatch({
        type: 'app/clearCaches',
        success: () => DeviceEventEmitter.emit('onRefreshPress', {}),
      })
    }
  }

  const timeZones = useSelector(clientConfigTimeZonesSelector)

  const timeZonesOptions = timeZones.map((tz) => ({
    text: tz,
    value: tz,
  }))

  const styles = useStyleSheet(themedStyles)

  const canImpersonate = User.hasFeature(MobileAppFeature.AdminImpersonate)

  const [timeZoneSelectDisabled, setTimeZoneSelectDisabled] = useState(false)
  const timeZoneTitle = 'Time Zone'

  const disableTimezoneSelect = () => {
    setTimeZoneSelectDisabled(true)
  }

  return (
    <View style={styles.container}>
      {canImpersonate && (
        <Section title="View">
          <Layout style={styles.autocomplete}>
            <AdminUserAutocomplete placeholder="Search Name" onSelect={disableTimezoneSelect} />
          </Layout>
        </Section>
      )}
      <Section title={timeZoneTitle}>
        <CommonSelect
          style={styles.autocomplete}
          options={timeZonesOptions}
          selectedOption={{ text: timeZone } as SelectOption}
          onSelect={onSelectTimeZone}
          disabled={timeZoneSelectDisabled}
          accessibilityLabel={timeZoneTitle}
          size="small"
        />
      </Section>
      <Section title="Build">
        <Text type="regular" bold style={styles.versionText}>
          {Apollo.env}
        </Text>
      </Section>
      <Section title="OTA Channel">
        <Text type="regular" bold style={styles.versionText}>
          {HotUpdater.getChannel()}
        </Text>
      </Section>
      <Section title="Endpoint">
        <Text type="regular" bold style={styles.versionText}>
          {Apollo.endpoint}
        </Text>
      </Section>
    </View>
  )
}

const themedStyles = StyleService.create({
  container: {
    flex: 1,
    backgroundColor: 'theme.background',
    paddingTop: 16,
  },
  autocomplete: {
    flex: 1,
  },
  versionText: {
    maxWidth: 240,
  },
})
